import React, {Component, Fragment} from 'react';
import {translate} from 'react-i18next';
import SupporterApi from '../../../apis/SupporterApi';
import AsyncSelect from 'react-select/lib/Async';
import moment from 'moment';
import {connect} from "react-redux";
import history from "../../../history";
import {NotificationManager} from "react-notifications";
import NameHelper from "../../../helpers/nameHelper";

const INITIAL_STATE = {
    isOpen: false,
    loading: false,
    isNewSupporter: true,
    lastname: '',
    firstname: '',
    email: '',
    supporter: null,
    sendMail: true,
    supporterProjectState: 'INVITED',
    periodId: undefined,
    errors: {}
};

class AddDialog extends Component {

    state = INITIAL_STATE;

    handleInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    };

    handleCheckboxChange = (e) => {
        this.setState({
            [e.target.name]: !this.state[e.target.name]
        })
    };

    handleFormSubmit = (e) => {
        const { t } = this.props;
        e.preventDefault();
        if (!this.state.loading) {
            this.setState({loading: true});
            SupporterApi.createOrAddSupporter({...this.state, supporter: this.state.supporter ? this.state.supporter.value : null})
                .then((response) => {
                    if (response.status === 200) {
                        if (response.data.success === true) {
                            if (this.state.supporterProjectState !== 'INVITED') {
                                history.push('/supporter/' + response.data.data.id);
                            } else {
                                if (this.props.onSupporterCreated) {
                                    this.props.onSupporterCreated();
                                }
                                NotificationManager.success(t('supporterList.addDialog.success'), t('default.notification.action.success'), 5000);
                            }
                            this.setState({...INITIAL_STATE});
                        } else {
                            this.setState({errors: response.data.errors, loading: false});
                        }
                    }
                })
        }
    };

    handleCancelAddSupporter = () => {
        this.setState({...INITIAL_STATE})
    };

    loadAvailableSupporters = (searchValue, callback) => {
        SupporterApi.getAvailableSupportersForProject(searchValue)
            .then((response) => {
                if (response.status === 200 && response.data.success) {
                    callback(response.data.data.map((el) => {
                        return {
                            value: el.id,
                            label: `${NameHelper.displayName(el)} (${el.email})`
                        }
                    }))
                }
            })
    };

    render() {
        const { availableSupporterProjectStates, availablePeriods, t} = this.props;
        return (
            <Fragment>
                <button type="button" className="btn btn-primary" onClick={() => this.setState({isOpen: true})}>
                    <i className="fa fa-plus inline-block m-r-sm"/>
                    {t('supporterList.addSupporter')}
                </button>
                {this.state.isOpen ? (
                    <div className="AddDialog modal inmodal in" tabIndex="-1" role="dialog" style={{display: 'block'}}>
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button className="close" onClick={this.handleCancelAddSupporter}>
                                        <span>x</span>
                                    </button>
                                    <h4 className="modal-title">
                                        {t('supporterList.addDialog.title')}
                                    </h4>
                                </div>
                                <form onSubmit={this.handleFormSubmit}>
                                    <div className="modal-body">
                                        <div className="row">
                                            <div className="col-xs-12">
                                                <div className="btn-group">
                                                    <button type="button"
                                                            className={`btn btn-${this.state.isNewSupporter ? 'primary' : 'default'}`}
                                                            onClick={() => this.setState({isNewSupporter: true})}>
                                                        {t('supporterList.addDialog.isNewSupporter.yes')}
                                                    </button>
                                                    <button type="button"
                                                            className={`btn btn-${!this.state.isNewSupporter ? 'primary' : 'default'}`}
                                                            onClick={() => this.setState({isNewSupporter: false})}>
                                                        {t('supporterList.addDialog.isNewSupporter.no')}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row m-t-lg">
                                            <div className="col-md-6">
                                                <div
                                                    className={"form-group" + ((this.state.errors && this.state.errors.lastname) ? ' has-error' : '')}>
                                                    <label>{t('supporterList.addDialog.lastname.label')} (optional)</label>
                                                    <input className="form-control" type="text" name="lastname"
                                                           value={this.state.lastname}
                                                           disabled={!this.state.isNewSupporter}
                                                           onChange={this.handleInputChange}/>
                                                    {(this.state.errors && this.state.errors.lastname) ? (
                                                        <span className="help-block">
                                                            {t('supporterList.addDialog.lastname.error.' + this.state.errors.lastname)}
                                                        </span>
                                                    ) : null}
                                                </div>
                                                <div
                                                    className={"form-group" + ((this.state.errors && this.state.errors.firstname) ? ' has-error' : '')}>
                                                    <label>{t('supporterList.addDialog.firstname.label')} (optional)</label>
                                                    <input className="form-control" type="text" name="firstname"
                                                           value={this.state.firstname}
                                                           disabled={!this.state.isNewSupporter}
                                                           onChange={this.handleInputChange}/>
                                                    {(this.state.errors && this.state.errors.firstname) ? (
                                                        <span className="help-block">
                                                            {t('supporterList.addDialog.firstname.error.' + this.state.errors.firstname)}
                                                        </span>
                                                    ) : null}
                                                </div>
                                                <div
                                                    className={"form-group" + ((this.state.errors && this.state.errors.email) ? ' has-error' : '')}>
                                                    <label>{t('supporterList.addDialog.email.label')}</label>
                                                    <input className="form-control" type="text" name="email"
                                                       value={this.state.email}
                                                       disabled={!this.state.isNewSupporter}
                                                       onChange={this.handleInputChange} />
                                                    {(this.state.errors && this.state.errors.email) ? (
                                                        <span className="help-block">
                                                            {t('supporterList.addDialog.email.error.' + this.state.errors.email)}
                                                        </span>
                                                    ) : null}
                                                </div>
                                                {availablePeriods && availablePeriods.length > 0 ? (
                                                    <div
                                                        className={"form-group" + ((this.state.errors && this.state.errors.period) ? ' has-error' : '')}>
                                                        <label>{t('supporterProject.period.label')} (optional)</label>
                                                        <select className="form-control" name="periodId"
                                                            onChange={this.handleInputChange}
                                                            value={this.state.periodId}>
                                                                     
                                                            <option value="">{null}</option>
                                                            {availablePeriods.map((el) => ( 
                                                                <option value={el.periodId}
                                                                    key={el.periodId}>
                                                                        {t('default.period.' + el.period, {
                                                                        startAt: moment(el.periodStartAt).format('DD.MM.'),
                                                                        endAt: moment(el.periodEndAt).format('DD.MM.')
                                                                    })}</option>
                                                            ))}
                                                        </select>
                                                        {(this.state.errors && this.state.errors.period) ? (
                                                            <span className="help-block">
                                                                {t('supporterDetails.period.error.' + this.state.errors.period)}
                                                            </span>
                                                        ) : null}
                                                    </div>
                                                ) : null}
                                            </div>
                                            <div className="col-md-6">
                                                <div
                                                    className={"form-group" + ((this.state.errors && this.state.errors.supporter) ? ' has-error' : '')}>
                                                    <label>{t('shiftDetails.supporterToAdd.label')}</label>
                                                    <AsyncSelect cacheOptions defaultOptions
                                                                 placeholder={t('supporterList.addDialog.supporterToAdd.placeholder')}
                                                                 value={this.state.supporter}
                                                                 loadOptions={this.loadAvailableSupporters}
                                                                 isDisabled={this.state.isNewSupporter}
                                                                 onChange={(value) => this.setState({supporter: value})}/>

                                                    {(this.state.errors && this.state.errors.supporter) ? (
                                                        <span className="help-block">
                                                                {t('supporterList.addDialog.supporterToAdd.error.' + this.state.errors.supporter)}
                                                            </span>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="hr-line-dashed"/>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div
                                                    className={"form-group" + ((this.state.errors && this.state.errors.sendMail) ? ' has-error' : '')}>
                                                    <label>{t('supporterList.addDialog.communication.label')}</label>
                                                    <div className="checkbox checkbox-default">
                                                        <input type="checkbox" name="sendMail"
                                                               id="addSupporter-sendPasswordMail-checkbox"
                                                               checked={this.state.sendMail}
                                                               onChange={this.handleCheckboxChange}/>
                                                        <label
                                                            htmlFor="addSupporter-sendPasswordMail-checkbox">{t('supporterList.addDialog.sendPasswordMail.label')}</label>
                                                    </div>

                                                    {(this.state.errors && this.state.errors.sendMail) ? (
                                                        <span className="help-block">
                                                    {t('supporterList.addDialog.sendMail.error.' + this.state.errors.sendMail)}

                                                </span>
                                                    ) : null}
                                                    {(this.state.errors && this.state.errors.mailTemplateKey) ? (
                                                        <span className="help-block text-danger">
                                                    {t('supporterList.addDialog.sendMail.error.' + this.state.errors.mailTemplateKey)}
                                                </span>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div
                                                    className={"form-group" + ((this.state.errors && this.state.errors.supporterProjectState) ? ' has-error' : '')}>
                                                    <label>{t('supporterList.addDialog.supporterProjectState.label')}</label>
                                                    <select className="form-control" name="supporterProjectState"
                                                            onChange={this.handleInputChange}
                                                            value={this.state.supporterProjectState}>
                                                        {availableSupporterProjectStates && availableSupporterProjectStates.map((supporterProjectState, i) => (
                                                            <option key={i}
                                                                    value={supporterProjectState}>{t('default.supporterProjectState.' + supporterProjectState)}</option>
                                                        ))}
                                                    </select>
                                                    {(this.state.errors && this.state.errors.supporterProjectState) ? (
                                                        <span className="help-block">
                                                    {t('supporterList.addDialog.supporterProjectState.error.' + this.state.errors.supporterProjectState)}
                                                </span>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button className="btn btn-default" type="button" onClick={this.handleCancelAddSupporter}>
                                            {t('default.cancel')}
                                        </button>
                                        <button className="btn btn-primary" type="submit" disabled={this.state.loading}>
                                            {this.state.loading ? (
                                                <i className='fa fa-spinner fa-spin inline-block m-r'/>
                                            ) : null}
                                            {t('translation.addEditDialog.submit')}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                ) : null}
            </Fragment>
        )
    }
}

const mapStateToProps = state => {
    return {
        availableSupporterProjectStates: state.supporterList.availableStates,
        availablePeriods: state.supporterList.availablePeriods
    }
};

export default connect(mapStateToProps, null)(translate()(AddDialog));